<template>
  <div class="weekday-checker--container">
    <div class="weekday-checker--flex">
      <div 
        v-for="item in weekdays" :key="item.value"
        @click="toggleCheck(item.value)"
        :class="{'btn-white': item.is_checked === false, 'btn-info': item.is_checked === true}"
        class="btn-badge">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeekdayChecker",
  data() {
    return {
      weekdays: [
        {name: 'Пн', value: 1, is_checked: false},
        {name: 'Вт', value: 2, is_checked: false},
        {name: 'Ср', value: 3, is_checked: false},
        {name: 'Чт', value: 4, is_checked: false},
        {name: 'Пт', value: 5, is_checked: false},
        {name: 'Сб', value: 6, is_checked: false},
        {name: 'Вс', value: 0, is_checked: false},
      ]
    };
  },
  props: {
    
  },
  computed: {},
  watch: {
    
  },
  methods: {
    toggleCheck(itemVal){
      for(let key in this.weekdays){
        if(this.weekdays[key].value === itemVal){
          this.$set(this.weekdays[key], 'is_checked', !this.weekdays[key].is_checked);
        }
      }
      this.emitComponent();
    },
    emitComponent(){
      let result = [];
      for(let key in this.weekdays){
        if(this.weekdays[key].is_checked === true){
          result.push(this.weekdays[key].value);
        }
      }
      this.$emit('emitComponent', result);
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.weekday-checker--flex{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;

  &>div{
    margin-top: 5px;
  }
}
</style>
